import { ProductListItem } from '../types/ProductTypes';

const HISTORY_KEY = 'cbp.product.history';
const MAX_HISTORY_SIZE = 50;

/**
 * Get the list of previously visited products from localStorage
 */
export const getProductHistory = (): ProductListItem[] => {
    try {
        const serializedHistory = localStorage.getItem(HISTORY_KEY);
        if (serializedHistory) {
            return JSON.parse(serializedHistory);
        }
    } catch (error) {
        console.error('Error reading product history:', error);
    }
    return [];
};

/**
 * Add a product to the visit history
 * Maintains a list of up to 10 most recently visited products
 */
export const addToProductHistory = (product: ProductListItem): void => {
    try {
        const history = getProductHistory();

        // Remove any existing copy of this product
        const filteredHistory = history.filter(p => p.id !== product.id);

        // Add the product to the beginning
        const newHistory = [product, ...filteredHistory];

        // Keep only the most recent MAX_HISTORY_SIZE products
        const trimmedHistory = newHistory.slice(0, MAX_HISTORY_SIZE);

        localStorage.setItem(HISTORY_KEY, JSON.stringify(trimmedHistory));
    } catch (error) {
        console.error('Error saving product history:', error);
    }
};

/**
 * Clear the product history
 */
export const clearProductHistory = (): void => {
    try {
        localStorage.removeItem(HISTORY_KEY);
    } catch (error) {
        console.error('Error clearing product history:', error);
    }
};

/**
 * Check if there is any product history
 */
export const hasProductHistory = (): boolean => {
    return getProductHistory().length > 0;
};
